import { render, staticRenderFns } from "./kaumxstrata.vue?vue&type=template&id=894a28ee&scoped=true"
import script from "./kaumxstrata.vue?vue&type=script&lang=js"
export * from "./kaumxstrata.vue?vue&type=script&lang=js"
import style0 from "./kaumxstrata.vue?vue&type=style&index=0&id=894a28ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894a28ee",
  null
  
)

export default component.exports